import { spacings, TTypographyProps, Typography } from '@guidde/design-system'
import { Stack } from '@mui/material'
import { LanguageSwitcher, type LanguageSwitcherProps } from './LanguageSwitcher'

type Props = {
    titleSize: Exclude<TTypographyProps['size'], 'xxl'>
    titleVariant: TTypographyProps['variant']
    title: string
} & LanguageSwitcherProps

export const PlaybookHeader = ({
    titleSize = 'lg',
    titleVariant = 'text',
    title,
    onLanguageChange,
    playbook,
    isRtl,
    buttonStyling,
}: Props) => (
    <Stack
        direction="row"
        spacing={spacings['lg']}
        sx={{
            direction: isRtl ? 'rtl' : 'ltr',
        }}
        alignItems="center"
        justifyContent="space-between"
    >
        <Typography
            variant={titleVariant}
            size={titleSize}
            color="grey.950"
            fontWeight="bold"
            canWrap
        >
            {title}
        </Typography>
        <LanguageSwitcher
            playbook={playbook}
            onLanguageChange={onLanguageChange}
            buttonStyling={buttonStyling}
            isRtl={isRtl}
        />
    </Stack>
)
